﻿/* Resources URLs */
export const MAP_RESOURCES_URL = 'map/resources?type=map';
export const MAP_UI_RESOURCES_URL = 'map/resources?type=mapUI';

/* Settings URLs */
export const MAP_GENERAL_SETTINGS_URL = 'map/mapgeneralsettings?id=';
export const MAP_GIS_SETTINGS_URL = 'map/getgissettings';
export const MAP_SAVE_GENERAL_SETTINGS_URL = 'map/mapform';
export const MAP_LAYERS_SETTINGS_URL = 'map/maplayerssettings?id=';
export const MAP_GENERAL_ACTIONS_SETTINGS_URL = 'uiaction/getgeneralactions?parentType=1&id=';
export const MAP_ENTITY_GET_FEATURE = 'map/getconfigfeature?';
export const MAP_TOOLTIP_DISPLAY_TYPES = 'map/gettooltipdisplaytypes';
export const MAP_ACTION_DISPLAY_TYPES = 'map/getfeatureactionmenudisplaytypes';
export const MAP_SYSTEM_COORDS = 'systcoord/getsystcoords?text=';
export const MAP_LAYER_PERM_TYPE = 'map/getmaplayerpermreqtype';
export const MAP_AVAILABLE_PLATFORMS = 'map/getplatforms';
export const MAP_GEOSERVICE_LAYERS = 'geoservice/getconfiggeoservices';
export const MAP_ENTITY_LAYERS = 'entity/getentities';
export const MAP_LAYER_LOADING_STRATEGY = 'map/getwfsloadingstrategies';
export const MAP_GEOSERVICE_FIELDS = 'geoservice/getgeoservicefields?id=';
export const MAP_LAYER_QLEGEND_TYPE = 'map/getqlegendtypes';
export const MAP_ENTITY_GEOMETRY_FIELDS = 'entity/getgeomfields?idEntity=';
export const MAP_ENTITY_GET_FIELDS = 'entity/getfieldsbyentityid?idEntity=';
export const MAP_LAYER_FORMATS = 'map/getlayeravailableformats?interpretation='
export const MAP_ENTITY_GET_STATISTICAL_FIELDS = 'entity/getstatisticalfields?idEntity='
export const GET_FIELD_DISTINCT = 'entity/getentityfielddistinctvalues?idEntity={0}&fieldName={1}&maxClasses={2}'

export const STYLE_FORM = 'style/styleform?id=';
export const STYLE_FORM_ADD = 'style/styleform';
export const STYLE_COPY_FORM = 'style/styleform?cpyFromId=';
export const PUBLISH_STYLE = 'style/publishsldxml';
export const DOWNLOAD_SLD_STYLE = 'style/getsld?id';
export const STYLE_DELETE = 'style/delete';
export const STYLE_GENERATE_PREVIEW_ALL = 'style/savepreviewmultiple';
export const PUBLISH_STYLE_ALL = 'style/publishmultiple';